/**
 * Configuration déclarative pour l'entité Association
 * Source unique de vérité pour tous les champs de Association
 */

import type { Association } from '../../types/association';
import { defineEntityConfig } from '../../lib/entity-config';

export const ASSOCIATION_CONFIG = defineEntityConfig<Association>({
  entityName: 'association',
  entityNamePlural: 'associations',

  fields: {
    name: {
      key: 'name',
      label: 'Association',
      type: 'text',
      required: true,
      sortable: true,
      showInTable: true,
      showInFilters: true,
      exportable: true,
      importable: true,
      size: 300,
      importValidation: (value) => {
        if (typeof value !== 'string') return 'Le nom doit être une chaîne de caractères';
        if (value.length < 2) return 'Le nom doit contenir au moins 2 caractères';
        return true;
      },
    },

    crews_count: {
      key: 'crews',
      label: 'Équipages',
      type: 'number',
      sortable: false,
      showInTable: true,
      showInFilters: false,
      exportable: true, // Exporté via le transformer custom
      importable: false,
    },
  },
});
